module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/32_49e8235544b6aca91c87b0ac9ba446db.jpg";